/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AttachmentEntity } from '../models/AttachmentEntity';
import type { UploadFileDto } from '../models/UploadFileDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class MediaService {
    /**
     * Upload a media file (image, video, audio)
     * @param formData Media file upload
     * @returns AttachmentEntity The file has been successfully uploaded
     * @throws ApiError
     */
    public static mediaControllerUploadFileV1(
        formData: UploadFileDto,
    ): CancelablePromise<AttachmentEntity> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/media/upload',
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * Get a fresh inline signed URL for an attachment (self-heal for expired image URLs)
     * @param id
     * @param variant
     * @returns any Returns a signed inline URL good for hours, plus its expiry
     * @throws ApiError
     */
    public static mediaControllerGetFreshUrlV1(
        id: string,
        variant: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/media/{id}/url',
            path: {
                'id': id,
            },
            query: {
                'variant': variant,
            },
        });
    }
    /**
     * Get a temporary download URL for an attachment
     * @param id
     * @returns any Returns a signed URL that triggers a file download
     * @throws ApiError
     */
    public static mediaControllerGetDownloadUrlV1(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/media/{id}/download-url',
            path: {
                'id': id,
            },
        });
    }
}
